module.exports = __webpack_public_path__ + "img/US@3x.870f1e06.png";